import { Injectable } from "@angular/core";
import { LeadsFilaItem } from "../../interfaces/leads-fila.interface";

@Injectable({
    providedIn: 'root'
})
export class PreAprovedHelperService {
    mapPreAprovado(item: LeadsFilaItem): string {
        if (item.preAprovado === 'S') {
            return 'Sim';
        } else if (item.preAprovado === 'N') {
            return 'Necessita Análise';
        } else {
            return 'Não Solicitado';
        }
    }
}
